import { Component, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CallbackModalComponent } from './callback-modal/callback-modal.component';

/**
 * Shown to a Sanlam Online customer who tries to register (or log in) on SCS. They have no SCS login,
 * so Continue sends them to Sanlam Online to sign in; they then finish registering on the SCS consent page.
 * Built on the same shared popup as the other platform popups (see LeaveVerificationModalComponent).
 */
@Component({
  selector: 'app-sol-user-modal',
  standalone: true,
  imports: [CallbackModalComponent],
  template: `
    <app-callback-modal
      headerLabel="Sanlam Online"
      title="Welcome to Sanlam Credit Solutions"
      [promptText]="message"
      [showCloseButton]="true"
      closeButtonId="btn_SolUserClose"
      closeButtonName="btn_SolUserClose"
      yesButtonLabel="Continue"
      [showNoButton]="false"
      yesButtonId="btn_SolUserContinue"
      yesButtonName="btn_SolUserContinue"
      (yesClick)="activeModal.close(true)"
      (closeClick)="activeModal.dismiss()">
    </app-callback-modal>
  `,
  // Only this popup: the shared callback-modal styles stay as they are for the other platforms. Keep in step with
  // #cc-sol-modal in the B2C login page so the two popups look the same.
  encapsulation: ViewEncapsulation.None,
  styles: [`
    app-sol-user-modal .popup-caption.popup-caption { font-size: 24px; }
   app-sol-user-modal header.pb-md-3 { padding-bottom: 0 !important; }
    app-sol-user-modal .popup-caption.popup-caption { margin: 6px 32px 6px 0; line-height: 1.2; }
    app-sol-user-modal .boxfooter .btnblue.btnblue { margin-bottom: 0 !important; }
    app-sol-user-modal .popupclose.popupclose { margin: 24px 24px 0 0; }
    @media (max-width: 575.98px) {
      app-sol-user-modal .popup-caption.popup-caption { font-size: 20px; margin: 6px 32px 6px 0; line-height: 1.2; }
      app-sol-user-modal .popupclose.popupclose { margin: 16px 16px 0 0; }
    }
  `]
})
export class SolUserModalComponent {
  readonly message =
    'Your existing Sanlam Online password cannot be used to log in for this platform. To access your Sanlam Credit Solutions dashboard, you\'ll need to login to Sanlam Online. Click on Continue to proceed.';

  constructor(public readonly activeModal: NgbActiveModal) {}
}
